<div class="sidebar">
  <div class="sidebar-header">
    <div class="logo cursor-pointer" routerLink="/">
      <img src="/images/sidebar/logo.svg" alt="Cladded Glass Logo" />
    </div>
  </div>


</div>
